// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"location-card-carousel_carouselWrapper__RWMDp","carouselSlide":"location-card-carousel_carouselSlide__JTk_q"};